import { SelectOption } from '~/shared/utils/types';
import {
  AUTOSCALING_ELIGIBILITY_PARAM_KEY,
  AUTOSCALING_STATE_PARAM_KEY,
  createAutoscalingStateFilters,
  createEligibilityFilters,
} from '~/shared/utils/autoscalingFilterUtils';

export {
  AUTOSCALING_ELIGIBILITY_PARAM_KEY,
  AUTOSCALING_STATE_PARAM_KEY,
  createAutoscalingStateFilters,
  createEligibilityFilters,
};

export const PROCESSED_FILTERS_PARAM_KEY = 'processed_filters';

export type FilterStoredInURL = Omit<SelectOption, 'group'> & {
  group: SelectOption['group'];
};

export function filterNonSpecificGroups(filters: FilterStoredInURL[]): SelectOption[] {
  return filters.filter((f) => {
    const isTagGroup = typeof f.group === 'string' && f.group.startsWith('tag:');
    return (
      f.group !== 'volumeId' &&
      f.group !== 'instanceId' &&
      f.group !== 'clusterName' &&
      f.group !== 'accountId' &&
      f.group !== 'autoscalingState' &&
      f.group !== 'supported' &&
      !isTagGroup
    );
  });
}

export function combineFilters(
  baseApiFilters: SelectOption[],
  pendingClusterNameFilters: SelectOption[],
  pendingVolumeIdFilters: SelectOption[],
  pendingVolumeTagFilters: SelectOption[],
  pendingAccountFilters: SelectOption[],
  pendingInstanceFilters: SelectOption[],
  autoscalingStateFilters: SelectOption[],
  eligibilityFilters: SelectOption[]
): SelectOption[] {
  return [
    ...baseApiFilters,
    ...pendingClusterNameFilters,
    ...pendingVolumeIdFilters,
    ...pendingVolumeTagFilters,
    ...pendingAccountFilters,
    ...pendingInstanceFilters,
    ...autoscalingStateFilters,
    ...eligibilityFilters,
  ];
}

export function buildAutoscalingApiFilters(
  stateIds: string[],
  eligibilityIds: string[]
): SelectOption[] {
  return [...createAutoscalingStateFilters(stateIds), ...createEligibilityFilters(eligibilityIds)];
}
